import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line no-duplicate-imports

import type { SubType } from "./Confirm.container";

export interface ConfirmState {
  id?: string;
  buttonNo?: string;
  buttonYes?: string;
  subType?: SubType;
  title?: string;
  icon?: string;
  content?: string;
  description?: string;
  showButtonNo?: boolean;
  showCloseIcon?: boolean;
}

const initialState: ConfirmState = {};

const confirmSlice = createSlice({
  name: "confirm",
  initialState,
  reducers: {
    yes() {
      return initialState;
    },
    no() {
      return initialState;
    },
    cancel() {
      return initialState;
    },
    hide() {
      return initialState;
    },
    show(state, action) {
      return {
        ...state,
        id: action.payload.id,
        subType: action.payload.subType,
        title: action.payload.title,
        icon: action.payload.icon,
        content: action.payload.content,
        buttonNo: action.payload.buttonNo,
        buttonYes: action.payload.buttonYes,
        description: action.payload.description,
        showButtonNo: action.payload.showButtonNo,
        showCloseIcon: action.payload.showCloseIcon
      };
    },
    destroy() {
      return initialState;
    }
  }
});

export default confirmSlice.reducer;
export const { yes, no, cancel, show, hide, destroy } = confirmSlice.actions;
export const confirmActions = confirmSlice.actions;
